exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.svg-icon[data-v-b6fa7d1a] {\n  margin-right: 10px;\n}\n.hideSidebar .menu-indent[data-v-b6fa7d1a] {\n  display: block;\n  text-indent: 10px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-b6fa7d1a","scoped":true,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js?{"sourceMap":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/views/layout/SidebarItem.vue
// module id = 260
// module chunks = 99